<span
  class="color-chip ellipsis"
  [style]="{ 'background-color': surface, color: textColor }"
>
  {{ content }}
</span>
